/** @format */

import React, { useState, useEffect, useRef } from "react";
import SecureStorage from "react-secure-storage";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom"; // ปรับให้ใช้ Routes กับ Route ตามโค้ดหลัก
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ReportPageMobile.css";
import { Modal } from "bootstrap";

import * as funcAll from "../../util/funcAll";

import NavbarMobileNew from "./NavbarMobileNew";
import ReportMobileTHNew from "./ReportMobileTHNew";
import ReportMobileENNew from "./ReportMobileENNew";
import FollowMobileTHNew from "./FollowMobileTHNew";
import FollowMobileENNew from "./FollowMobileENNew";

import FooterTH from "../menu/Footer-TH";
import FooterEN from "../menu/Footer-EN";
import AboutUsEN from "./AboutUsEN";
/////////////   Redux  //////////////
import { saveLanguageWeb } from "../store/LanguageSlice";
import { useSelector, useDispatch } from "react-redux";

const constants = require("file-configs/constants");

export default function ReportPageMobile(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const globalData = useSelector((state) => ({ ...state }));
  const [openBurger, setOpenBurger] = useState(false);
  const [typePage, setTypePage] = useState("report");
  const [ticketNav, setTicketNav] = useState(null);

  function handleOpenBurger() {
    setOpenBurger(!openBurger);
  }

  function handleBtnWindowBurgerClick(type) {
    setOpenBurger(false);
    if (type === "report") {
      setTypePage(type);
      navigate("report");
    }
    if (type === "follow") {
      setTypePage(type);
      navigate("track");
    }
  }

  const handleGoFollowPage = (check) => {
    if (check === true) {
      setTypePage("follow");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
      }}>
      <NavbarMobileNew
        checkOpenBurger={handleOpenBurger}
        openBurger={openBurger}
        type={typePage}
        ticketNav={ticketNav}
      />

      {openBurger === true ? (
        <div className="window-openBurger">
          <div className="container-btn">
            <button
              className="btn"
              onClick={() => handleBtnWindowBurgerClick("report")}>
              <i
                class="fa-regular fa-message"
                style={{ marginRight: "1rem" }}></i>

              <p>
                {globalData.language.toggle_language === true
                  ? "แจ้งเรื่องใหม่"
                  : "Submit New Issue"}
              </p>
            </button>

            <button
              className="btn"
              style={{ marginTop: "0" }}
              onClick={() => handleBtnWindowBurgerClick("follow")}>
              <i
                class="fa-regular fa-rectangle-list"
                style={{ marginRight: "1rem" }}></i>
              <p>
                {globalData.language.toggle_language === true
                  ? "ติดตามความก้าวหน้า"
                  : "Track progress"}
              </p>
            </button>
          </div>
        </div>
      ) : null}

      {/* ปรับการใช้ Routes และ Route */}
      <Routes>
        {globalData.language.toggle_language === true ? (
          <>
            <Route
              path="/report"
              element={
                <ReportMobileTHNew
                  goToFollowPage={(check) => handleGoFollowPage(check)}
                />
              }
            />
            <Route
              path="/track/*"
              element={
                <FollowMobileTHNew
                  reloadNav={(ticket) => setTicketNav(ticket)}
                />
              }
            />
            <Route path="/about/*" element={<AboutUsEN />} />
          </>
        ) : (
          <>
            <Route
              path="/report"
              element={
                <ReportMobileENNew
                  goToFollowPage={(check) => handleGoFollowPage(check)}
                />
              }
            />
            <Route
              path="/track/*"
              element={
                <FollowMobileENNew
                  reloadNav={(ticket) => setTicketNav(ticket)}
                />
              }
            />
            <Route path="/about/*" element={<AboutUsEN />} />
          </>
        )}
      </Routes>

      {/* {globalData.language.toggle_language === true ? (
        <FooterTH />
      ) : (
        <FooterEN />
      )} */}
    </div>
  );
}
